var refreshPageTrack = function refreshPageTrack(currentUrl, previousUrl) {
  window.DEAnalytics.ajaxRefreshPageTrack({
    url: currentUrl,
    previousUrl: previousUrl
  });
};

export var logPageView = function logPageView(currentUrl, previousUrl) {
  if (!previousUrl) {
    return;
  }

  if (!window.DEAnalytics) {
    // The analytics global does not exist yet, so
    // set a listener that will execute as soon as it is ready
    window.addEventListener('DOMContentLoaded', function () {
      refreshPageTrack(currentUrl, previousUrl);
    });
  } else {
    refreshPageTrack(currentUrl, previousUrl);
  }
};